import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { 
  requestAPIActions 
} from 'loopback-react-request';

import '../TroughAdd/TroughAdd.scss';
import { isConfigurationEditable } from 'src/redux/utils.redux';

export interface TroughQtyAddProps {
  plateBuilder: GlobalPrivateState['plateBuilder'];
  configuration: GlobalPrivateState['configuration'];
  dispatch: Function;
  troughId: string;
  warning: GlobalPrivateState['warning'];
}

export class TroughQtyAddPartial extends React.Component<TroughQtyAddProps> {
  
  constructor(props: TroughQtyAddProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  public render() {    
    const { warning } = this.props;
    return (
      <div className="partial-trough-add">
        <button 
          className="trough-icon trough-icon-add"
          onClick={this.handleClick}
          disabled={warning.requireReset.qty.required || this.disabled}
        >
          <span className="add" />
        </button>
      </div>
    );
  }

  private get disabled(): boolean {
    const configuration = this.props.configuration.result;

    if (!configuration) { return true; }
    
    const trough = configuration.selectedTrough && configuration.selectedTrough.trough;
    
    if (!trough) { return true; }

    if (!this.quantity) {
      return true;
    }

    let maxTroughs = 6;
    if (this.props.plateBuilder) {
      maxTroughs = this.props.plateBuilder.calc.getMaxTroughQty(trough); // TODO - want to use memoization, but with React Classes seems like a pain in the ass... would have to refactor this component into a function
    }

    return !isConfigurationEditable() || this.quantity >= maxTroughs || this.props.configuration.updating;
  }

  private get quantity(): number | null | undefined {
    const { configuration } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.selectedTrough && 
      configuration.result.selectedTrough.qty;
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }
  
  private handleClick() {
    const { troughId } = this.props;
    if (!this.quantity || this.disabled) {
      return;
    }
    const qty = this.quantity + 1;
    if (this.configurationId && qty !== this.quantity ) {
      
      this.props.dispatch(requestAPIActions.load(
        'configuration',
        { 
          url: `/Configurations/${this.configurationId}`,
          options: {
            method: 'PATCH',
            data: {
              troughId: troughId,
              selectedTrough: {
                qty: qty,
              },
            },
          },
        },
        true
      ));
    }
  }
}

export const TroughQtyAdd = connect((state: GlobalPrivateState) => ({
  plateBuilder: state.plateBuilder,
  configuration: state.configuration,
  warning: state.warning,
}))(TroughQtyAddPartial);

export default TroughQtyAdd;
